<template>
  <el-dialog title="处理领用申请" :visible="visible" width="640px" append-to-body :close-on-click-modal="false" @close="close">
    <el-descriptions v-if="record && record.id" :column="2" border class="claim-summary">
      <el-descriptions-item label="申请单号">{{ record.requestNo || '-' }}</el-descriptions-item>
      <el-descriptions-item label="申请人">{{ record.applicantUserNameSnapshot || '-' }}</el-descriptions-item>
      <el-descriptions-item label="管理归属">{{ managementText(record.managementType) }}</el-descriptions-item>
      <el-descriptions-item label="资产分类">{{ record.categoryNameSnapshot || '-' }}</el-descriptions-item>
      <el-descriptions-item label="申请资产" :span="2">{{ record.requestedAssetName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="用途" :span="2">{{ record.purpose || '-' }}</el-descriptions-item>
    </el-descriptions>
    <el-form ref="handleForm" :model="form" :rules="rules" label-width="96px" class="claim-handle-form">
      <el-form-item label="分配资产" prop="assetId">
        <el-select v-model="form.assetId" :loading="assetLoading" filterable placeholder="请选择闲置资产" style="width:100%" @change="onAssetChange">
          <el-option v-for="item in availableAssets" :key="item.id" :label="assetOptionLabel(item)" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="交付位置" prop="toLocation"><el-input v-model="form.toLocation" maxlength="200" /></el-form-item>
      <el-form-item label="处理说明"><el-input v-model="form.remark" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button class="danger-button" :loading="submitting" @click="reject">驳回申请</el-button>
      <el-button type="primary" :loading="submitting" @click="approve">确认分配资产</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { listAssets, handleAssetClaim } from '@/api/crm/asset'

export default {
  name: 'AssetClaimProcessDialog',
  props: {
    visible: { type: Boolean, default: false },
    record: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      assetLoading: false,
      submitting: false,
      availableAssets: [],
      form: { requestId: null, approved: true, assetId: null, toLocation: '', remark: '' },
      rules: {
        assetId: [{ required: true, message: '请选择要分配的闲置资产', trigger: 'change' }],
        toLocation: [{ required: true, message: '请输入交付位置', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(value) {
      if (value) this.initialize()
    },
    record: {
      deep: true,
      handler() {
        if (this.visible) this.initialize()
      }
    }
  },
  methods: {
    initialize() {
      const row = this.record || {}
      this.availableAssets = []
      this.form = { requestId: row.id, approved: true, assetId: null, toLocation: '', remark: '' }
      this.$nextTick(() => this.$refs.handleForm && this.$refs.handleForm.clearValidate())
      if (!row.id) return
      this.assetLoading = true
      listAssets({ pageNum: 1, pageSize: 500, status: 10, managementType: row.managementType }).then(res => {
        this.availableAssets = (res.rows || [])
          .filter(item => !item.pendingOperationId)
          .sort((a, b) => Number(Number(b.categoryId) === Number(row.categoryId)) - Number(Number(a.categoryId) === Number(row.categoryId)))
        if (!this.availableAssets.length) this.msgWarning('当前管理归属下暂无可分配的闲置资产')
      }).finally(() => { this.assetLoading = false })
    },
    managementText(value) { return value === 'HR' ? '人事行政' : '仓库' },
    assetOptionLabel(item) {
      const sameCategory = Number(item.categoryId) === Number((this.record || {}).categoryId) ? '（同分类）' : ''
      return `${item.assetCode} / ${item.assetName}${sameCategory}`
    },
    onAssetChange(id) {
      const asset = this.availableAssets.find(item => Number(item.id) === Number(id)) || {}
      this.form.toLocation = asset.storageLocation || ''
    },
    approve() {
      this.$refs.handleForm.validate(valid => {
        if (!valid) return
        this.submitting = true
        handleAssetClaim(Object.assign({}, this.form, { approved: true })).then(() => {
          this.msgSuccess('资产已分配，等待领用人确认')
          this.finish()
        }).finally(() => { this.submitting = false })
      })
    },
    reject() {
      this.$prompt('请输入驳回原因', '驳回领用申请', {
        confirmButtonText: '确认驳回', cancelButtonText: '取消', inputType: 'textarea',
        inputValidator: value => Boolean(value && value.trim()) || '请输入驳回原因'
      }).then(({ value }) => {
        this.submitting = true
        return handleAssetClaim({ requestId: this.record.id, approved: false, remark: value.trim() })
      }).then(() => {
        this.msgSuccess('领用申请已驳回')
        this.finish()
      }).catch(() => {}).finally(() => { this.submitting = false })
    },
    finish() {
      this.$emit('update:visible', false)
      this.$emit('success')
    },
    close() { this.$emit('update:visible', false) }
  }
}
</script>

<style scoped>
.claim-summary { margin-bottom:18px; }
.claim-handle-form { padding-top:4px; }
.danger-button { color:#f56c6c; border-color:#fbc4c4; }
</style>
